import { FirebaseAuth } from "../utils/firebase";
import moment from "moment-timezone";

export async function getAuthHeader() {
  const tokenResult = await FirebaseAuth.currentUser?.getIdTokenResult();
  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  let token: string | null | undefined = tokenResult?.token;

  if (moment(tokenResult?.expirationTime) <= moment()) {
    // token invalid
    const refreshedToken = await FirebaseAuth.currentUser?.getIdTokenResult(true);
    token = refreshedToken?.token;
  }
  if (!token) {
    console.error("NO TOKEN FOUND");
    token = localStorage.getItem("AUTH_TOKEN");
  }
  /**
   * ***** WARNING ****
   *  `superagent` requires Authorization to either be a string, or null
   * DO NOT SET `Authorization` to `undefined` because you will break sign in flow
   * See https://app.datadoghq.com/incidents/102
   */
  return { Authorization: token };
}
